<template>
  <template v-if="item.children && item.children.length && !item.hideChildrenInMenu">
    <el-sub-menu :index="item.path">
      <template #title>
        <div class="icon-box" v-if="item?.meta?.icon">
          <svg class="icon" aria-hidden="true">
            <use :xlink:href="`#icon-${item.meta.icon}${activeMenu.includes(item.path) ? '-xuanzhong' : ''}`"></use>
          </svg>
        </div>
        <span>
          <template v-if="orderBadge[item.name]*1">
            <el-badge class="badge" :value="orderBadge[item.name]" :max="99" :offset="[5, 18]">
              {{ $t(item.meta.title) }}
            </el-badge>
          </template>
          <template v-else>
            {{ $t(item.meta.title) }}
          </template>
        </span>
      </template>
      <!-- 递归调用自身渲染子菜单 -->
      <MenuItem v-for="child in item.children" :key="child.path" :item="child" :activeMenu="activeMenu"
                :order-badge="orderBadge" />
    </el-sub-menu>
  </template>

  <el-menu-item v-else :index="item.path">
    <div class="icon-box" v-if="item?.meta?.icon">
      <svg class="icon" aria-hidden="true">
        <use :xlink:href="`#icon-${item.meta.icon}${activeMenu.includes(item.path) ? '-xuanzhong' : ''}`"></use>
      </svg>
    </div>
    <template #title>
      <template v-if="orderBadge[item.name]*1">
        <el-badge :value="orderBadge[item.name]" :max="99" :offset="[5, 15]">
          {{ $t(item.meta.title) }}
        </el-badge>
      </template>
      <template v-else>
        <span>{{ $t(item.meta.title) }}</span>
      </template>
    </template>
  </el-menu-item>
</template>

<script setup>
import './iconfont/iconfont.js'
import { $t } from '@/i18n'

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  activeMenu: {
    type: String,
    required: true
  },
  orderBadge: {
    type: Object,
    required: true
  }
})

</script>

<style scoped lang="scss">
/* 你可以在这里添加样式 */
.badge {
  :deep(.el-badge__content) {

  }
}
</style>
